module.exports = __webpack_public_path__ + "static/media/RM_logo.be518403.png";